// removed by extract-text-webpack-plugin
module.exports = {"ndaBtns":"ndaBtns"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadTooling/UploadTooling.scss
// module id = 5286
// module chunks = 1